<template>
    <div>

        <div id="popup-mask" v-if="bookInfoState.activeVideoData && bookInfoState.activeVideoData.type==='popup' &&  data.isInFullScreen"
             @click="removeActiveVideoData"
        >
        </div>
        <video autoplay v-if="bookInfoState.activeVideoData && bookInfoState.activeVideoData.type==='popup'" id="popup-video"
               :src="data.videoPath"
               :class="data.classPopupVideo"
               type="video/mp4"
               controls
        >
            <source :src="data.videoPath" type="video/mp4">
        </video>


        <!-- :style="data.stylePopupVideo"-->
        <video autoplay controls  v-if="bookInfoState.activeVideoData && bookInfoState.activeVideoData.type==='inline'"
               class="inline-video"
               :style="data.styleRect"
               :src="data.videoPath"
               type="video/mp4"
        >
            <source :src="data.videoPath" type="video/mp4">
        </video>
    </div>
</template>

<script>
    import {ref, reactive, onMounted, onUpdated, watchEffect, watch, computed, nextTick}  from "vue";
    import {useParser} from "@/modules/reader/annotations/parser";
    import {useBookInfo} from "@/modules/reader/book/bookinfo";
    import {usePageResize} from "@/modules/reader/book/pageResize";
    import {useAnnotationHelper} from "@/modules/reader/annotations/annotationHelper";
    import {isTouchDevice} from "@/modules/utils/deviceUtils";
    import {updateFileNameIfMultipleSpeech} from  "@/modules/utils/pathUtils";
    import cssvar from "@/scss/_variables.scss";
    import axios from "axios";

    const colorRect = cssvar.colorRect;
    const zindexVideoPopup = cssvar.zindexVideoPopup;
    const {getResizedAnnotationPos} = useAnnotationHelper();

    export default {

        props: {
          annot:Object
        },
        setup(props, context) {

            const { parserState, readData} = useParser();
            const { bookInfoState, removeActiveVideoData} = useBookInfo();
            const { pageResizeState} = usePageResize();

            const data = reactive({
                isInFullScreen:false,
                vidoeWidth:0,
                videoHeight:0,
                styleRect:computed(()=>{

                    if (!props.annot) {
                        return null;
                    }
                    let domPos = props.annot.domPos;
                    return {
                        ...getResizedAnnotationPos(domPos),
                        position:"absolute"
                    }
                }),
                videoPath:computed(()=>{

                        if (bookInfoState.activeVideoData) {
                            return bookInfoState.activeVideoData.src;
                        }

                        return null;

                }),
                classPopupVideo:computed(()=>{
                    return {
                        "popup-video-touch": isTouchDevice()
                    }
                }),
                stylePopupVideo:computed(()=>{
                    return {
                        width:isTouchDevice() ? data.vidoeWidth : "auto",
                        height:isTouchDevice() ? data.videoHeight: "auto"
                    }
                })
            });

            onMounted(() => {
                //for deskt  /*
                document.addEventListener('fullscreenchange', (event) => {
                    if (
                        !(document.fullscreenElement ||
                            document.webkitFullscreenElement ||
                            document.mozFullScreenElement ||
                            document.msFullscreenElement)
                    ) {
                        removeActiveVideoData();
                    } else {
                        data.isInFullScreen = true;
                    }
                });

            })

            watchEffect(()=>{

                if (bookInfoState.activeVideoData &&  bookInfoState.activeVideoData.type==='popup') {
                    nextTick(()=> {
                        let videoEl = document.getElementById("popup-video");
                        videoEl.addEventListener("loadedmetadata",(e)=>{
                            if (videoEl && data.videoPath && bookInfoState.activeVideoData.type === 'popup') {

                                //desktop firefox, desktop chrome, iPad firefox
                                if (videoEl.requestFullscreen) {
                                    videoEl.requestFullscreen();
                                } else if (videoEl.msRequestFullscreen) {
                                    videoEl.msRequestFullscreen();
                                //desktop safari, iPad safari not work since full screen mode requires click trigger on the full-screen-element,
                                //and this behavior doesn't apply to iReader video
                                /*
                                } else if (videoEl.webkitRequestFullscreen) {
                                    //videoEl.webkitRequestFullscreen();
                                 */
                                //manually render video as overlay if fullscreen is not supported (e.g. iPad Chrome, desktop/iPad safari
                                } else {
                                    let videoWidth = e.target.videoWidth;
                                    let videoHeight = e.target.videoHeight;
                                    let videoRatio = videoWidth / videoHeight;
                                    let windowRatio = window.innerWidth / window.innerHeight;
                                    e.target.style.zIndex = zindexVideoPopup;

                                    if (videoRatio >= windowRatio) {
                                        data.videoWidth = "100%";
                                        data.videoHeight = "auto";

                                        e.target.style.width = "100%";
                                        e.target.style.height = "auto";

                                        let scaledVideoHeight = videoHeight * window.innerWidth / videoWidth;
                                        e.target.style.top = `${0.5 * (window.innerHeight - scaledVideoHeight)}px`

                                    } else {
                                        data.videoHeight = "100%";
                                        data.videoWidth = "auto"

                                        e.target.style.width = "auto";
                                        e.target.style.height = "100%";

                                        let scaledVideoWidth = videoWidth * window.innerHeight / videoHeight;
                                        e.target.style.top = 0;
                                        e.target.style.left = `${0.5 * (window.innerWidth - scaledVideoWidth)}px`

                                    }

                                    data.isInFullScreen = true;
                                }
                            }


                        });

                    });
               }

            })

            return {
                props,
                data,
                pageResizeState,
                bookInfoState,
                parserState,
                removeActiveVideoData,
                getResizedAnnotationPos,
                isTouchDevice
            }

        }
    }

 </script>


<style scoped lang="scss">

    #popup-video {
        position:absolute;
        //z-index:-1; //set z-index: -1 so that the video won't show when preparing to render full-screen
    }
    
    #popup-mask {
        width:100%;
        height:100%;
        position:fixed;
        background:rgba(0,0,0,0.5);
        left:0;
        top:0;
        z-index:$zindex-video-popup-touch-mask;
    }

    //for touch device, when fullscreen not supported
    .popup-video-touch {
        position:fixed !important;
        left:0;
        top:0;
        z-index:$zindex-video-popup-touch;
    }

    .inline-video {
        z-index:$zindex-inline-video;
    }

</style>